import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./index.scss";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import { QueryClient, QueryClientProvider } from "react-query";
import AuthProvider from "./providers/AuthProvider";
import interceptor from "./api/client";
import AdminProvider from "./providers/AdminProvider";
import MessageProvider from "./providers/MessageProvider";
import SquadProvider from "./providers/SquadProvider";
import SettingsProvider from "./providers/SettingsProvider";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false,
      retry: false,
      staleTime: 5 * 60 * 1000,
    },
  },
});

interceptor();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Router>
    <QueryClientProvider client={queryClient}>
      <SettingsProvider>
        <AuthProvider>
          <AdminProvider>
            <SquadProvider>
              <MessageProvider>
                <App />
              </MessageProvider>
            </SquadProvider>
          </AdminProvider>
        </AuthProvider>
      </SettingsProvider>
    </QueryClientProvider>
  </Router>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
